import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dt-node" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "dt-passup",
  title: "PASE: no cuelga de quien lo patrocinó — su patrocinador no calificaba y subió a alguien de más arriba"
}
const _hoisted_4 = { class: "dt-name" }
const _hoisted_5 = {
  key: 0,
  class: "fas fa-anchor dt-anchor"
}
const _hoisted_6 = { class: "dt-sub" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "dt-detail-of" }
const _hoisted_9 = {
  key: 0,
  class: "dt-detail-warn"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  class: "dt-kids"
}
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draft_tree_subtree = _resolveComponent("draft-tree-subtree", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dt-card", _ctx.cardClass]),
      title: _ctx.card.tooltip
    }, [
      (_ctx.item.side)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["dt-side", 'dt-side-' + _ctx.item.side]),
            "aria-hidden": "true"
          }, _toDisplayString(_ctx.item.side === "left" ? "I" : "D"), 3))
        : _createCommentVNode("", true),
      (_ctx.card.isPassUp)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.card.isAnchor)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.card.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.card.sub), 1),
      (_ctx.card.detail)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "dt-detail",
            title: _ctx.card.detail.title
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.card.detail.prefix), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.card.detail.value), 1),
            (_ctx.card.detail.warn)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.hasChildren)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "dt-toggle",
            title: _ctx.collapsed ? 'Desplegar' : 'Plegar',
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, _toDisplayString(_ctx.collapsed ? "+" + _ctx.item.descendants : "−"), 9, _hoisted_10))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    (_ctx.hasChildren && !_ctx.collapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slots, (slot) => {
            return (_openBlock(), _createElementBlock("div", {
              key: slot.key,
              class: _normalizeClass(["dt-slot", { 'dt-slot-empty': !slot.item }])
            }, [
              (slot.item)
                ? (_openBlock(), _createBlock(_component_draft_tree_subtree, {
                    key: 0,
                    item: slot.item,
                    mode: _ctx.mode
                  }, null, 8, ["item", "mode"]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "dt-empty",
                    title: 'Pierna ' + _ctx.sideName(slot.side)
                  }, _toDisplayString(slot.side === "left" ? "I" : "D"), 9, _hoisted_12))
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}